import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import {loadPreregistrationPageDataAction} from './State/actions';
import {getEpiData} from '../../Utils/epiHelpers';

import Loader from '../../UI/Loader';
import ErrorMessage from '../../UI/ErrorMessage';
import RawHtml from '../../UI/RawHtml';
import Accordion from '../../UI/Accordion';
import RegistrationListing from './Components/RegistrationListing';

import definitions from '../../Style/LfStyleDefinitions';
import {mediaQuery, clearFix} from '../../Style/cssHelpers';

class InsurancePreregistrationPage extends React.Component {
    constructor(props) {
        super(props);
        this.heading = getEpiData('heading', this.props.mountRootId);
        this.preamble = getEpiData('preamble', this.props.mountRootId);
    }

    static get propTypes() {
        return {
            mountRootId: PropTypes.string.isRequired
        }
    }

    componentDidMount() {
        this.props.loadData();
    }

    render() {
        const Header = ({preamble}) => (
            <HeaderWrapper>
                <Heading>{this.heading}</Heading>
                <Preamble>
                    <RawHtml>{preamble}</RawHtml>
                </Preamble>
            </HeaderWrapper>
        );

        if (this.props.hasErrored) {
            return (
                <React.Fragment>
                    <Header preamble={this.preamble}/>
                    <ErrorMessage message={`Ooops! Ett fel har uppstått: ${typeof this.props.error === 'string' ? this.props.error : this.props.error.message}`} />
                </React.Fragment>
            );
        }

        if (this.props.isLoading) {
            return (
                <React.Fragment>
                    <Header preamble=""/>
                    <Loader color={definitions.colors.blueBackground} />
                </React.Fragment>
            );
        }

        const hasMemberRegs = this.props.data.memberRegistrations.length > 0;
        const hasCoInsRegs = this.props.data.coRegistrations.length > 0;
        const hasAnimalRegs = this.props.data.animalRegistrations.length > 0;

        return (
            <React.Fragment>
                <Header
                    preamble={!hasMemberRegs && !hasCoInsRegs && !hasAnimalRegs
                        ? 'Du har just nu inga påbörjade hälsodeklarationer'
                        : this.preamble
                    }
                />

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    {hasMemberRegs &&
                        <Accordion
                            title="För medlem"
                            noBackground={true}
                            hideOverflow={false}
                            headerComponent={
                                <RegistrationListing registrations={this.props.data.memberRegistrations} />
                            }
                            noHeaderPadding={true}
                            unexpandable
                        />
                    }

                    {hasCoInsRegs &&
                        <Accordion
                            title="För medförsäkrad"
                            noBackground={true}
                            hideOverflow={false}
                            headerComponent={
                                <RegistrationListing registrations={this.props.data.coRegistrations} />
                            }
                            noHeaderPadding={true}
                            unexpandable
                        />
                    }

                    {hasAnimalRegs &&
                        <Accordion
                            title="För djur"
                            noBackground={true}
                            hideOverflow={false}
                            headerComponent={
                                <RegistrationListing registrations={this.props.data.animalRegistrations} />
                            }
                            noHeaderPadding={true}
                            unexpandable
                        />
                    }
                </motion.div>
            </React.Fragment>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.preregistrationPageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(loadPreregistrationPageDataAction())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InsurancePreregistrationPage);

export const HeaderWrapper = styled.div`
    position: relative;
    margin: 0;
    padding: 0;
`;

export const Heading = styled.h1`
    font-family: ${definitions.fonts.heading};
    font-size: 48px;
    color: ${definitions.colors.almostBlack};

    ${mediaQuery.small(`
        font-size: 28px;
    `)}
`;

export const Preamble = styled.div`    
    margin-bottom: 40px;

    font-family: ${definitions.fonts.main};
    font-size: 20px;
    color: ${definitions.colors.almostBlack};

    ${mediaQuery.large(`
        margin: 0;       
        font-size: 16px;
    `)}
`;
